import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SportsHandballRoundedIcon from '@mui/icons-material/SportsHandballRounded';
import SectionCard from './ui/SectionCard';
import EmptyState from './ui/EmptyState';
import PlayerAvatar from './ui/PlayerAvatar';
import tokens from '../theme/tokens';

/**
 * Ranking de goleiros da temporada: menor média de gols sofridos por pelada primeiro.
 * `goleiros`: [{ goleiro, nome, peladas, golsSofridos, media }]; `destaque`: id do goleiro logado.
 */
const RankingGoleiros = ({ goleiros = [], destaque, limite = 10, sx, subtitle = 'Menor média de gols sofridos por pelada' }) => (
  <SectionCard title="Ranking de goleiros" subtitle={subtitle} icon={<SportsHandballRoundedIcon color="primary" />} sx={sx}>
    {goleiros.length === 0 ? (
      <EmptyState title="Sem gols sofridos lançados" description="Os números aparecem quando os goleiros são escalados nas partidas ou a diretoria lança os gols sofridos na pelada." />
    ) : (
      <Stack spacing={0.75}>
        {goleiros.slice(0, limite).map((g, i) => {
          const eu = destaque && g.goleiro && String(g.goleiro) === String(destaque);
          return (
            <Stack
              key={g.goleiro || g.nome}
              direction="row"
              spacing={1.25}
              alignItems="center"
              sx={{ px: 1, py: 0.75, borderRadius: 2, bgcolor: eu ? tokens.color.brandSoft : 'transparent', border: eu ? `1px solid ${tokens.color.brand}` : '1px solid transparent' }}
            >
              <Box sx={{ width: 24, textAlign: 'center', fontWeight: 700, color: i < 3 ? tokens.color.gold : 'text.secondary' }}>{i + 1}</Box>
              <PlayerAvatar name={g.nome} size={34} />
              <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                <Typography variant="body2" fontWeight={600} noWrap>{g.nome}{eu ? ' (você)' : ''}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {g.peladas} pelada{g.peladas === 1 ? '' : 's'} · {g.golsSofridos} gol{g.golsSofridos === 1 ? '' : 's'} sofrido{g.golsSofridos === 1 ? '' : 's'}
                </Typography>
              </Box>
              <Box sx={{ textAlign: 'right', flexShrink: 0 }}>
                <Typography fontWeight={700} sx={{ lineHeight: 1.1 }}>{String(g.media).replace('.', ',')}</Typography>
                <Typography variant="caption" color="text.secondary">por pelada</Typography>
              </Box>
            </Stack>
          );
        })}
      </Stack>
    )}
  </SectionCard>
);

export default RankingGoleiros;
